import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import OtpInput from "react-otp-input";
import ReCAPTCHA from "react-google-recaptcha";
import { Grid, Button, Typography, Box, styled } from "@mui/material";
import { addErrorMessage, addNewMessage, addSuccessMessage } from "../slice";
import useInterval from "use-interval";
import { useRemainedSecond } from "../hooks";
import { USERS_API } from "../api";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import Footer from "./Footer";

const CustomOtpInput = styled("input")(() => ({
  display: "inline-block",
  width: "15% !important",
  maxWidth: "3.5rem !important",
  // height: "2.8rem",
  aspectRatio: "1/1",
  backgroundColor: "#EEEEEE",
  margin: "5px",
  border: "1px solid #68618F",
  outline: "none",
  borderRadius: 8,
  color: "#7B7B7B",
  boxSizing: "border-box",
  padding: "0.3rem",
  fontWeight: "bold",
  fontSize: "1.2rem",
  fontStyle: "normal",
  "&::-webkit-outer-spin-button,&::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
  },
  MozAppearance: "textfield",
}));

function Otp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const recaptcha = useRef();
  const [otp_value, setOtp_value] = useState("");
  const [captchaToken, setCaptchaToken] = useState();
  const { remained_second, setRemained_second } = useRemainedSecond();
  let actionType = window.sessionStorage.getItem("action-type");

  const { mutate: forgotPasswordSendVerification } = useMutation(
    ({ username, isByEmail }) => USERS_API.ForgotPasswordSendVerification(username, isByEmail),
    {
      onError: ({ response }) => {
        setRemained_second(parseInt(response?.data?.data.validSeconds));
        dispatch(addErrorMessage(response));
      },
      onSuccess: ({ data }) => {
        setRemained_second(parseInt(data?.data.validSeconds));
        dispatch(addSuccessMessage(data?.message));
      },
    }
  );

  const { mutate: sendVerification } = useMutation(
    ({ username, isByEmail }) => USERS_API.SendVerification(username, isByEmail, captchaToken),
    {
      onError: ({ response }) => {
        setRemained_second(parseInt(response?.data?.data.validSeconds));
        dispatch(addErrorMessage(response));
      },
      onSuccess: ({ data }) => {
        setRemained_second(parseInt(data?.data.validSeconds));
        dispatch(addSuccessMessage(data?.message));
      },
    }
  );

  const { mutate: verfiy } = useMutation(
    () => {
      switch (actionType) {
        case "isByEmail":
          let email = window.sessionStorage.getItem("email");
          return USERS_API.ConfirmEmail(otp_value, email);
        case "isByPhoneNumber":
          let phoneNumber = window.sessionStorage.getItem("phoneNumber");
          return USERS_API.ConfirmPhoneNumber(otp_value, phoneNumber);
        default:
          break;
      }
    },
    {
      onError: ({ response }) => {
        dispatch(addErrorMessage(response));
      },
      onSuccess: ({ data: { message } }) => {
        navigate("/sign-up/result");
        dispatch(addSuccessMessage(message));
      },
    }
  );

  useInterval(
    () => {
      setRemained_second(remained_second - 1);
    },
    remained_second > 0 ? 1000 : null
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (otp_value.length === 6) {
      if (actionType === "forgetPassword_email" || actionType === "forgetPassword_phoneNumber") {
        window.sessionStorage.setItem("otp_value", otp_value);
        navigate("/sign-in/new-password");
      } else {
        verfiy();
      }
    } else {
      //todo: inja byd error drst sahih vared nashdn code ro handle knim
    }
  };

  const handleResendMessage = useCallback(() => {
    let email = "";
    let phoneNumber = "";

    switch (actionType) {
      case "isByEmail":
        email = window.sessionStorage.getItem("email");
        if (!recaptcha?.current?.getValue()) {
          dispatch(
            addNewMessage({
              id: "check-recaptcha",
              text: "لطفا من ربات نیستم را انتخاب نمایید.",
              type: "error",
            })
          );
        } else return sendVerification({ username: email, isByEmail: true });
        break;
      case "isByPhoneNumber":
        phoneNumber = window.sessionStorage.getItem("phoneNumber");
        if (!recaptcha?.current?.getValue()) {
          dispatch(
            addNewMessage({
              id: "check-recaptcha",
              text: "لطفا من ربات نیستم را انتخاب نمایید.",
              type: "error",
            })
          );
        } else return sendVerification({ username: phoneNumber, isByEmail: false });
        break;
      case "forgetPassword_email":
        email = window.sessionStorage.getItem("forgetPassword_email");
        return forgotPasswordSendVerification({ username: email, isByEmail: true });
      case "forgetPassword_phoneNumber":
        phoneNumber = window.sessionStorage.getItem("phoneNumber");
        return forgotPasswordSendVerification({ username: phoneNumber, isByEmail: false });
      default:
        break;
    }
  }, [actionType, forgotPasswordSendVerification, sendVerification]);

  useEffect(() => {
    if (remained_second === -1) {
      handleResendMessage();
    }
  }, [remained_second, handleResendMessage]);

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      fontFamily="VazirMedium"
      position="relative"
      marginTop="auto"
    >
      <form onSubmit={handleSubmit}>
        <Box
          container
          xs={4}
          bgcolor="#fff"
          borderRadius={5}
          maxWidth={550}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={4}
          sx={{ boxSizing: "border-box" }}
          py={{ xs: 1, sm: 2, md: 4 }}
          px={{ xs: 1, sm: 4, md: 6 }}
        >
          <Logo1 />
          <Typography variant="h1" mt={10} mb={2}>
            تایید کد فعال سازی
          </Typography>
          <Typography variant="h2" my={2} textAlign="center">
            برای ثبت نام کامل کد ارسال شده به موبایل خود را اینجا وارد کنید
          </Typography>
          <OtpInput
            value={otp_value}
            onChange={(e) => setOtp_value(e)}
            numInputs={6}
            renderInput={(props) => <CustomOtpInput {...props} type="number" />}
          />
          <Button
            variant="xl"
            my={2}
            sx={{ ":hover": { backgroundColor: "transparent" }, mt: "1.2rem" }}
            onClick={handleResendMessage}
            disabled={remained_second > 0}
          >
            {remained_second > 0 && (
              <span style={{ marginRight: "0.5rem" }}>
                {`${("0" + parseInt(remained_second / 60)).slice(-2)}:${(
                  "0" + parseInt(remained_second % 60)
                ).slice(-2)}`}
              </span>
            )}
            دوباره ارسال کن
          </Button>
          {remained_second <= 0 && (
            <ReCAPTCHA
              sitekey="6LfjzkopAAAAAMVFkngsSsFNBRsNZin7b991NfVA"
              ref={recaptcha}
              hl="fa"
              onChange={(token) => {
                setCaptchaToken(token);
              }}
            ></ReCAPTCHA>
          )}
          <Button type="submit" variant="l" sx={{ my: 3 }}>
            بعدی
          </Button>
        </Box>
      </form>
      <Footer />
    </Grid>
  );
}

export default Otp;
